import "./breadcrumbs.css";
import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import { Link } from "react-router";
import { getObject } from "../../common/app/breadcrumbs";
import { Map } from "immutable";

export default class Breadcrumbs extends Component {
  constructor(props) {
    super(props);
  }

  getPropsPathFromArray(array) {
    let path = [];
    const self = this;
    array.forEach(function(item, index) {
      if (item.type === "propsPath") {
        let subpath = self.getPropsPathFromArray(item.key);
        let obj = self.props[item.collection];
        subpath.forEach(function(item, index) {
          if (Map.isMap(obj)) {
            obj = obj.get(item);
          } else {
            obj = obj[item];
          }
        });
        path.push(obj);
      } else if (item.type === "static") {
        path.push(item.name);
      }
    });
    return path;
  }

  render() {
    const { location } = this.props;

    let breadcrumbs = [];
    const path = location.pathname;
    const bcmbs = path.split("/");
    bcmbs.shift();

    let obj = undefined;
    for (let i = 0; i < bcmbs.length; i++) {
      obj = getObject(obj, bcmbs[i]);
      if (obj == undefined) {
        continue;
      }
      let name = obj.name;
      let path = "";

      for (let j = 0; j <= i; j++) {
        path += "/" + bcmbs[j];
      }

      if (name === "dynamic") {
        if (
          this.props[bcmbs[i - 1]] &&
          this.props[bcmbs[i - 1]][bcmbs[i - 1]].entities.get(bcmbs[i])
        ) {
          name = "";
          const self = this;
          obj.key.forEach(function(item) {
            let word = undefined;
            if (typeof item === "object") {
              word = self.props[bcmbs[i - 1]][bcmbs[i - 1]].entities.get(
                bcmbs[i]
              );
              item.forEach(function(wordItem) {
                word = word.get(wordItem);
              });
            } else if (typeof item === "string") {
              word = self.props[bcmbs[i - 1]][bcmbs[i - 1]].entities.getIn([
                bcmbs[i],
                item
              ]);
            } else if (typeof item === "number") {
              word = String.fromCharCode(item);
            }
            name += word + " ";
          });
        } else {
          name = "loading...";
        }
      } else if (name === "propsPath") {
        name = this.props[obj.collection].getIn(
          this.getPropsPathFromArray(obj.key)
        );
      }

      let bc = {
        name: name,
        path: path,
        depth: i,
        isVisible: obj.isVisible,
        noLink: obj.noLink
      };
      if (obj.isVisible !== false) {
        breadcrumbs.push(bc);
      }
    }

    const depth = breadcrumbs.length;
    return (
      <ul className="breadcrumbs-list">
        {breadcrumbs.length > 1 &&
          breadcrumbs.map((item, index) => (
            <div className="breadcrumb-wrapper" key={item.path}>
              {index >= 0 &&
              item.isVisible !== false && (
                <li key={index}>
                  {item.path && (
                    <div className="breadcrumb-separator">
                      {index <= depth && index >= 1 && ">"}
                    </div>
                  )}
                  {index !== depth - 1 &&
                  !item.noLink && (
                    <Link
                      onlyActiveOnIndex={true}
                      activeClassName="breadcrumb-active"
                      to={item.path || ""}
                    >
                      {item.name}
                    </Link>
                  )}
                  {(index === depth - 1 || item.noLink) && item.name}
                </li>
              )}
            </div>
          ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/breadcrumbs.react.js